export const GROUPES_ALIMENTAIRES_IDS = {
  CEREALES: 1,
  FRUITS: 2,
  OLEAGINEUX: 3,
  HUILE: 4,
  LEGUMES: 5,
  LEGUMINEUSES: 6,
  OEUFS: 7,
  PATATE: 8,
  PRODUITS_LAITIERS: 9,
  SUCRE: 10,
  VIANDE_BLANCHE: 11,
  VIANDE_ROUGE: 12,
};

export const GROUPES_ALIMENTAIRES = {
  CEREALES: {
    libelle: "Céréales",
    id: GROUPES_ALIMENTAIRES_IDS.CEREALES,
  },
  FRUITS: {
    libelle: "Fruits",
    id: GROUPES_ALIMENTAIRES_IDS.FRUITS,
  },
  OLEAGINEUX: {
    libelle: "Fruits oléagineux",
    id: GROUPES_ALIMENTAIRES_IDS.OLEAGINEUX,
  },
  HUILE: {
    libelle: "Huiles",
    id: GROUPES_ALIMENTAIRES_IDS.HUILE,
  },
  LEGUMES: {
    libelle: "Légumes",
    id: GROUPES_ALIMENTAIRES_IDS.LEGUMES,
  },
  LEGUMINEUSES: {
    libelle: "Légumineuses",
    id: GROUPES_ALIMENTAIRES_IDS.LEGUMINEUSES,
  },
  OEUFS: {
    libelle: "Oeufs",
    id: GROUPES_ALIMENTAIRES_IDS.OEUFS,
  },
  PATATE: {
    libelle: "Pommes de terre",
    id: GROUPES_ALIMENTAIRES_IDS.PATATE,
  },
  PRODUITS_LAITIERS: {
    libelle: "Produits laitiers",
    id: GROUPES_ALIMENTAIRES_IDS.PRODUITS_LAITIERS,
  },
  SUCRE: {
    libelle: "Sucre",
    id: GROUPES_ALIMENTAIRES_IDS.SUCRE,
  },
  VIANDE_BLANCHE: {
    libelle: "Viande blanche",
    id: GROUPES_ALIMENTAIRES_IDS.VIANDE_BLANCHE,
  },
  VIANDE_ROUGE: {
    libelle: "Viande rouge",
    id: GROUPES_ALIMENTAIRES_IDS.VIANDE_ROUGE,
  },
};
